import React from 'react';
import { Camera } from 'lucide-react';

function AddMediaPrompt({ onClick }) {
  return (
    <div className="add-media-prompt-subtle" onClick={onClick}>
      <span className="prompt-text">Have photos from this memory?</span>
      <button className="prompt-link">
        <Camera size={14} />
        Add Photos or Video
      </button>
    </div>
  );
}

export default AddMediaPrompt;
